"use client";
import { ImageTypeHandler } from "@/app/(components)/Basic/ImageTypeHandler";
import { ReactTable } from "@/app/(components)/Basic/ReactTable";
import { UserLink } from "../../User/UserLink";
import DefaultProfile from "@/assets/graphics/default-profile.svg";
import FollowStarIcon from "@/assets/icons/follow-star.svg";
import { User } from "@/api/users/types";
import useInfiniteArtistReviews from "../../ArtOrder/ArtOrderReview/hooks/useInfiniteArtistReviews";
import { Rating } from "@/app/(components)/Basic/Rating";

export interface Props {
  artist: User;
}

const ArtistReviewTable = ({ artist }: Props) => {
  const { reviews, hasNextPage, fetchNextPage } = useInfiniteArtistReviews({
    artistId: artist.id,
  });

  const columns = [
    {
      Header: "",
      accessor: "user",
      Cell: ({ row }: any) => (
        <div className="flex items-center w-fit">
          <UserLink
            artist={row.original.reviewer}
            tooltipPosition={["center", "top"]}
          >
            <div className="relative box-content w-20 h-20 rounded-full overflow-hidden">
              {row.original.reviewer.imageUrl ? (
                <ImageTypeHandler
                  alt="Profile image"
                  src={row.original.reviewer.imageUrl}
                  placeholder={row.original.reviewer.imagePlaceholder}
                  fill
                />
              ) : (
                <DefaultProfile />
              )}
            </div>
          </UserLink>
          <div>
            <div className="flex flex-col gap-y-2 ml-5 lg:ml-9">
              <Rating
                rating={row.original.rating}
                starClassName="w-8 pr-1"
                locked
              />
              <p className="ml-1 text-secondary">{row.original.text}</p>
            </div>
          </div>
        </div>
      ),
    },
  ];

  return (
    <>
      <div className="flex flex-col lg:flex-row items-center mb-10 gap-y-6 justify-between">
        <div className="flex gap-x-4">
          <FollowStarIcon className="w-6 fill-grey" />
          <span className="text-lg font-light whitespace-nowrap">
            Average review
            <span className="font-semibold ml-3">
              {!artist.avgRating ? 0 : Number(artist.avgRating).toFixed(1)}
            </span>
          </span>
        </div>
      </div>
      <ReactTable
        columns={columns}
        data={reviews}
        showMoreButton={hasNextPage}
        hideColumnHeader
        className="border-t border-grey"
        rowClassName="flex-col w-full py-4"
        cellClassName="w-full lg:w-auto py-0 lg:py-6"
        showMoreHandler={fetchNextPage}
      />
    </>
  );
};

export default ArtistReviewTable;
